import PropTypes from 'prop-types';
// @mui
import { styled } from '@mui/material/styles';
import {
  Step,
  Stepper,
  StepLabel,
  StepConnector,
  stepConnectorClasses,
  Typography,
} from '@mui/material';
// components
import Iconify from '../../components/Iconify';
import useResponsive from '../../hooks/useResponsive';

// ----------------------------------------------------------------------

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 11,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: theme.palette.primary.main,
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: theme.palette.primary.main,
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 2,
    border: 0,
    borderRadius: 1,
    backgroundColor: theme.palette.divider,
  },
}));

const ColorlibStepIconRoot = styled('div')(({ theme, ownerState }) => ({
  width: 24,
  height: 24,
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  justifyContent: 'center',
  color: theme.palette.common.white,
  backgroundColor: theme.palette.text.disabled,
  ...(ownerState.active && {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.common.black,
  }),
  ...(ownerState.completed && {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.common.black,
  }),
}));

ColorlibStepIcon.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
  completed: PropTypes.bool,
  icon: PropTypes.number,
};

function ColorlibStepIcon(props) {
  const { active, completed, className } = props;

  const icons = {
    1: <Typography variant="body2">1</Typography>,
    2: <Typography variant="body2">2</Typography>,
    3: <Typography variant="body2">3</Typography>,
  };

  return (
    <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
      {completed 
      ? <Iconify icon="ic:outline-check" width={16} height={16} /> 
      : icons[String(props.icon)]
      }
    </ColorlibStepIconRoot>
  );
}

export default function FliersDetailStepper({ step }) {
  const smUp = useResponsive('up', 'sm');
  const STEPS = [
    <Typography key="1" variant={smUp ? "subtitle2" : "overline"}>크루에게 커피챗 제안하기</Typography>,
    <Typography key="2" variant={smUp ? "subtitle2" : "overline"}>크루의 커피챗 수락</Typography>,
    <Typography key="3" variant={smUp ? "body2" : "caption"}><b>커피챗 진행</b> (Zoom 미팅)</Typography>,
  ];

  return (
    <>
      <Stepper alternativeLabel activeStep={step} connector={<ColorlibConnector />}>
        {STEPS.map((label, index) => (
          <Step key={`l-${index}`}>
            <StepLabel
              StepIconComponent={ColorlibStepIcon}
              sx={{
                ".MuiStepLabel-label.MuiStepLabel-alternativeLabel": {
                  mt: 1,
                }
              }}
            >{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </>
  );
}
